import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import {NgsRevealModule} from 'ngx-scrollreveal';

import { BackComponent } from '../back/back.component';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { WorkHeaderComponent } from '../work-header/work-header.component';
import { AnimationsComponent } from '../animations/animations.component';


@NgModule({
  imports: [
    SharedRoutingModule,
    NgsRevealModule
  ],
  declarations: [
    BackComponent,
    FooterComponent,
    HeaderComponent,
    WorkHeaderComponent,
    AnimationsComponent
  ],
  exports: [
    CommonModule,
    BackComponent,
    FooterComponent,
    HeaderComponent,
    WorkHeaderComponent,
    AnimationsComponent
  ]
})
export class SharedModule { }